/**
 * Lead Detail has no URL of its own — it replaces the list in place under
 * `/marketing/leads` — so the selected tab is component state, not a route param.
 */
export const LEAD_DETAIL_TABS = ['overview', 'pets', 'forms', 'booking', 'notes'] as const;

export type LeadDetailTab = (typeof LEAD_DETAIL_TABS)[number];

export const DEFAULT_LEAD_DETAIL_TAB: LeadDetailTab = 'overview';

export const LEAD_DETAIL_TAB_LABELS: Record<LeadDetailTab, string> = {
    overview: 'Overview',
    pets: 'Pets',
    forms: 'Forms',
    booking: 'Booking',
    notes: 'Notes'
};
